<template>
<div class="success" name="success">
  <topNav :title="title" @click-left="onClickLeft"></topNav>
  <div class="payContent">
    <div class="success_tip">
      <img src="../../../static/images/pay_for_success_img.png" alt="">
      <p>温馨提示：开通无感支付可享受更快捷的停车体验</p>
    </div>
    <div class="open_info">
      <p class="qrcode" v-if="qrcodeUrl"><img :src="qrcodeUrl" alt=""></p>
      <p v-if="qrcodeUrl">{{ tips }}</p>
    </div>
    
    <!-- 广告模块 -->
    <!-- <div class="ads-container success-ads" v-if="WX_H5_PCSK.imageUrl">
      <div class="ads-wrapper" @click="routeToAdsPage(WX_H5_PCSK)">
        <div class="ads-cover"></div>
        <span class="ads-flag">广告</span>
        <van-icon class="ads-close" name="cross" size="22px" color="red" @click="handleCloseAd(WX_H5_PCSK)" />
        <img :src="WX_H5_PCSK.imageUrl" alt="">
      </div>
    </div> -->
    
  </div>
</div>

</template>
<script>
import topNav from "../topnav/topnav";
import {DETAIL as API} from "@/assets/api";
import { AD_URL } from "@/assets/api"
import { Icon } from 'vant'
export default {
  name: 'paydetail',
  components:{
      topNav,
      [Icon.name]: Icon,
  },
  data() {
    return {
      title:"缴费成功",
      qrcodeUrl:"",
      qrcodeImg: {
        dev: {
          wx: '../../../static/images/qr_wx_dev.png',
          al: '../../../static/images/qr_al_dev.png',
        },
        pro: {
          wx: '../../../static/images/qr_wx_pro.png',
          al: '../../../static/images/qr_al_pro.png',
        },
      },
      tips: '',
      
      ads: ['WX_H5_PCSK'],
      WX_H5_PCSK: {
        apiUrl: AD_URL + '?bCommid=00000165&ads=WX_H5_PCSK',
        type: 'WX_H5_PCSK',
        browserType: 'wx',
        adUrl: '',
        imageUrl: '',
      },
    }
  },
  mounted(){
    this.showCode()
    // this.ads.forEach(el => {
    //   this.commonUtil.getAds(this[el])
    // });
  },
  methods:{
    bind_card(){
      this.$router.push('/nofeel');
    },
    showCode(){
      var env = window.location.host.indexOf('beta') == -1 ? 'pro' : 'dev'
      var type = this.commonUtil.browserType()
      type = 'wx'
      this.qrcodeUrl = this.qrcodeImg[env][type]
      this.tips =  type == 'wx' ? '长按识别图中二维码' : '长按保存生活号二维码'
    },
    routeToAdsPage(ad, index){
        this.commonUtil.routeToAdsPage(ad, index)
    },
    handleCloseAd(ad){
      ad.adUrl = ''
      ad.imageUrl = ''
    },
  },

}
</script>
<style lang="less">
  .pay_btn {
      width: 92%;
      text-align: center;
      height: 2.6rem;
      line-height: 2.6rem;
      background-color: rgb(70,135,248);
      color: white;
      margin: .8rem auto;
      border-radius: 5px;
      font-size: 1rem;
      -webkit-box-shadow: 0.1rem 0.1rem 0.7rem #A3A3A3;
      box-shadow: 0rem 0.2em 0.8rem #5b82c18a;
  }

  .success_tip, .open_info{
    margin-top: 6%;
    img{
      width: 40%;
      margin-bottom: 10px;
    }
    p{
      font-size: 13px;
      line-height: 1.5;
    }
  }
  .open_info{
    img{
      width: 55%;
    }
  }
  
  @keyframes fadeIn {
      0% {
          opacity: 0;
          transform: translate(0, 20px);
      }
      100% {
          opacity: 1;
          transform: translate(0, 0);
      }
  }
  .ads-container{
    .ads-wrapper{
      margin: 0 auto;
      position: relative;
      
      animation-name: fadeIn;
      animation-duration: 1.5s;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
      opacity: 0;
      img{
        display: block;
        max-width: 100%;
      }
      .ads-cover{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }
      .ads-flag{
        display: block;
        font-weight: bold;
        color: #ff0000;
        font-size: 14px;
        line-height: 18px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .ads-close{
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    &.success-ads{
        padding-top: 30px;
        .ads-wrapper{
            width: 92%;
            img{
                display: block;
                max-width: 100%;
            }
        }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/paydetail/success.vue